__webpack_require__.p = "/klinik/";